// extracted by mini-css-extract-plugin
module.exports = {"container":"_392dTeIFvEeaiaEi2mtP8e","block":"_13dlrkmwOCc500jR0xsHy9","blockName":"_1q2fs8w-BCT--1aKXgtNRs","blockValue":"_1p7nf08eoHNr9F-YzmqpAm"};